import {propOr} from 'ramda';

import {SimpleProductType} from 'constants/flow/flowTypesProduct';
import {QuoteItemType, QuoteItemBaseType} from 'constants/flow/flowTypesCart';
import {CheckoutQuoteItemType} from 'constants/flow/flowTypes';

import {convertPriceEEC} from 'libs/convertPrice/convertPrice';

/**
 * Return base price for cart item (for glasses it's frame price)
 * @param {SimpleProductType | QuoteItemType} quoteItem - quote item
 * @return {string} base price
 */
export const getPrice = (
    quoteItem: SimpleProductType | QuoteItemType | CheckoutQuoteItemType,
): string => {
    const {price} = propOr(quoteItem, 'frame', quoteItem);
    return convertPriceEEC(price || 0);
};

/**
 * Return regular price
 * @param {SimpleProductType} product - product
 * @return {string} regular price
 */
export const getRegularPrice = (product: SimpleProductType): string =>
    convertPriceEEC(product.regular_price_with_tax || product.product_final_price || product.price);

/**
 * Return discounted price
 * @param {QuoteItemType | CheckoutQuoteItemType} product - product item
 * @return {string} discounted price
 */
export const getDiscountedPrice = (product: QuoteItemBaseType | CheckoutQuoteItemType): string => {
    let price = 0;

    if ('discounted_price' in product) {
        price = product.discounted_price * Number(product.qty || 1);
    } else if ('rowTotalDiscountedPrice' in product) {
        price = product.rowTotalDiscountedPrice;
    }

    return convertPriceEEC(price);
};

/**
 * Function to get correct data for dimension36 for CL
 * @param {number} price - price for single item, can be with or without discount
 * @param {number} totalPrice - total price for item including boxes and packages without discounts
 * @param {number} finalPrice - total price for item including boxes and packages, can be with discount
 * @returns {number} price for single item without discounts
 */
export const getPriceForContactsEEC = (price = 0, totalPrice = 0, finalPrice = 0) => {
    if (totalPrice === finalPrice) return price;
    return totalPrice - finalPrice;
};
